import { MessageCircle } from "lucide-react";
import { CONTACT_INFO } from "@/data/siteData";

const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${CONTACT_INFO.whatsapp.replace(/\+/g, '')}?text=Hi%2C%20I%27m%20interested%20in%20your%20services`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="whatsapp-modern whatsapp-pulse"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </a>
  );
};

export default WhatsAppButton;
